import { Component, OnInit, ViewContainerRef } from '@angular/core';
import { Http, Response } from '@angular/http';
import { REDEEM_INVESTOR } from '../models/Redeem';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { HeaderService } from '../header.service';
import { ProfileService } from '../profile.service';
import * as Globals from '../globals';

@Component({
  selector: 'app-redemption-confirm',
  templateUrl: './redemption-confirm.component.html',
  styleUrls: ['./redemption-confirm.component.css']
})
export class RedemptionConfirmComponent implements OnInit {

  checked: boolean;
  idtyNo: string;
  urlFile = Globals.archiveUrl + 'bids?code=';
  redeems: REDEEM_INVESTOR[];
  dataRedeems: REDEEM_INVESTOR[];
  tab: number = 1;
  search: string = '';
  loading: boolean;
  seriesId: number;
  totRedeem: number = 0;
  series: any[];
  userProfile: any;
  authMenu: any;
  checkItems: number = 0;
  paramSeries: any = { OPEN: false };
  p: number = 1;
  colSort: string[] = ['STAT_REDEEM'];
  reverse: boolean = true;
  col: number = 8;
  constructor(private http: Http, public toastr: ToastsManager, vRef: ViewContainerRef, private headerService: HeaderService, private profileService: ProfileService) {
    this.toastr.setRootViewContainerRef(vRef);
    this.authMenu = { M_FLAG: null };
  }
  ngOnInit() {
    this.redeems = [];
    this.dataRedeems = [];
    if (!this.profileService.userProfile) {
      this.profileService.signOut();
    } else {
      this.userProfile = this.profileService.userProfile;
      this.getSeries();
      this.authMenu = Globals.getAuthMenu(203, this.userProfile);
    }
  }
  sort(val: number) {
    this.col = val;
    this.reverse = !this.reverse;
    switch (val) {
      case 1:
        this.colSort = ['IDTY_NO'];
        break;
      case 2:
        this.colSort = ['INV_NAME'];
        break;
      case 3:
        this.colSort = ['REDEMP_ID'];
        break;
      case 4:
        this.colSort = ['ALT_AMT'];
        break;
      case 5:
        this.colSort = ['BID_DATE'];
        break;
      case 6:
        this.colSort = ['REDEEM_AMT'];
        break;
      case 7:
        this.colSort = ['SELLING_AGENT'];
        break;
      case 8:
        this.colSort = ['STAT_REDEEM'];
        break;
      default:
        break;
    }
  }
  setCheck(val: boolean) {
    for (var i = 0; i < this.redeems.length; i++) {
      if (this.redeems[i].ATTACHMENT && this.redeems[i].STAT_REDEEM == '0') {
        this.redeems[i].CHECKED = val;
        if (val) {
          this.checkItems++;
        } else {
          this.checkItems = 0;
        }

      }
    }
  }
  seriesChanged(ev: any) {
    this.seriesId = ev.target.value;
    this.getRedeems();
    for (var i = 0; i < this.series.length; i++) {
      if (this.seriesId == this.series[i].SERIES_ID) {
        this.paramSeries = this.series[i];
        break;
      }
    }
    /*if (!this.paramSeries.OPEN) {
      this.toastr.warning('Masa penawaran telah berakhir');
    }*/
  }
  setConfirm(val: any) {
    this.dataRedeems = [];
    for (var i = 0; i < this.redeems.length; i++) {
      if (this.redeems[i].CHECKED) {
        this.redeems[i].STAT_REDEEM = val;
        this.dataRedeems.push(this.redeems[i]);
      }
    }
    if (this.dataRedeems.length > 0) {
      this.http.put(Globals.serviceUrl + 'ritel/confirmbids?id=' + this.userProfile.USER_ID, this.dataRedeems, { headers: this.headerService.getHeader() })
        .subscribe((res: Response) => {
          this.checkItems = 0;
          this.checked = false;
          this.toastr.success('Data berhasil disimpan');
          this.loading = false;
          this.getRedeems();
        }, err => {
          console.log(err);
          this.toastr.error(Globals.errorMessage(err));
          this.loading = false;
        });
    }
  }
  getRedeems() {
    this.loading = true;
    this.http.get(Globals.serviceUrl + 'ritel/redeems?seriesId=' + this.seriesId + '&search=' + this.search + '&t=' + new Date().getTime(), { headers: this.headerService.getHeader() })
      .subscribe((res: Response) => {
        this.redeems = res.json();
        this.totRedeem = 0;
        this.checkItems = 0;
        for (var i = 0; i < this.redeems.length; i++) {
          this.totRedeem += this.redeems[i].REDEEM_AMT;
        }
        this.loading = false;
      }, err => {
        console.log(err);
        this.toastr.error(Globals.errorMessage(err));
        this.loading = false;
      });
  }
  getSeries() {
    this.loading = true;
    this.http.get(Globals.serviceUrl + 'ritel/redeemactive?t=' + new Date().getTime(), { headers: this.headerService.getHeader() })
      .subscribe((res: Response) => {
        this.series = res.json();
        if (this.series.length > 0) {
          this.seriesId = this.series[0].SERIES_ID;
          for (var i = 0; i < this.series.length; i++) {
            if (this.seriesId == this.series[i].SERIES_ID) {
              this.paramSeries = this.series[i];
              break;
            }
          }
          /*if (!this.paramSeries.OPEN) {
            this.toastr.warning('Masa penawaran telah berakhir');
          }*/
          this.getRedeems();
        } else if (this.series.length == 0) {
          //this.toastr.warning('Masa penawaran telah selesai');
          this.loading = false;
        } else {
          this.loading = false;
        }
      }, err => {
        console.log(err);
        this.toastr.error(Globals.errorMessage(err));
        this.loading = false;
      });
  }
  getCheckItems() {
    this.checked = false;
    this.checkItems = 0;
    for (var i = 0; i < this.redeems.length; i++) {
      if (this.redeems[i].CHECKED) {
        this.checkItems++;
      }
    }
  }

}



// WEBPACK FOOTER //
// C:/Users/oggy.yuristantyo/source/Workspaces/UI_SBN_Ritel_Web/src/app/redemption-confirm/redemption-confirm.component.ts